type WaitForCondition = (
  check: () => boolean,
  timeSeconds?: number,
) => { promise: Promise<void>; cancel: () => void }
type WaitForConditionRejectionReason = {
  type: 'error' | 'cancel'
  message?: string
}

const waitForCondition: WaitForCondition = (
  check: () => boolean,
  timeSeconds = 10,
) => {
  let timeoutId: NodeJS.Timeout | undefined = undefined
  let rejectFn:
    | ((reason?: WaitForConditionRejectionReason) => void)
    | undefined = undefined

  const promise = new Promise<void>((resolve, reject) => {
    rejectFn = reject
    const endTime = Date.now() + timeSeconds * 1000

    const attempt = (): void => {
      try {
        if (check()) {
          resolve()
        } else if (Date.now() < endTime) {
          timeoutId = setTimeout(attempt, 300)
        } else {
          rejectFn?.({
            type: 'error',
            message: `Timeout: Waiting for ${timeSeconds} seconds. Still no sign of the target`,
          })
        }
      } catch (e) {
        rejectFn?.({
          type: 'error',
          message: e?.message,
        })
      }
    }

    attempt()
  })

  const cancel = (): void => {
    clearTimeout(timeoutId)
    rejectFn?.({
      type: 'cancel',
    })
  }

  return { promise, cancel }
}

export type { WaitForConditionRejectionReason }
export default waitForCondition
